import type { FC } from 'react';

import Chip from './Chip';

type Props = {
  createdAt: Date;
  format?: 'short' | 'long';
  variant?: 'successTransparent' | 'successBg';
  className?: string;
};

const NewOfferChip: FC<Props> = ({
  createdAt,
  format = 'short',
  variant = 'successTransparent',
  className,
}) => {
  const daysBetween = Math.round(
    (new Date().getTime() - createdAt.getTime()) / (1000 * 60 * 60 * 24)
  );

  if (daysBetween > 2) return null;
  return (
    <Chip
      className={className}
      variant={variant}
      label={
        format === 'long'
          ? 'New offer - be the first one to apply!'
          : 'New offer'
      }
    />
  );
};

export default NewOfferChip;
